module.exports = {

    type: {
        EVENTS_CALENDAR: 1,
        EVENTS_SUMMARY: 4,

        EXTERNAL_URI: 2,
        TODAY_TASKS: 3,
        ACTIVE_PROJECTS: 5,
        TEAM_BOARD: 6,
        HIGH_PRIORITIES: 7,
        TASKS_BOARD_SYSTEM: 8,
        PROJECT_SUMMARY: 9,
        TASKS_BOARD_BY_USER : 10,

        THANK_YOU: 11
    },

    list: {
        7: 'Priorities',
        10: 'Tasks by user',
        11: 'Thank you'
    }
};